import { render, staticRenderFns } from "./BrandTable.vue?vue&type=template&id=08b241a5&scoped=true&"
import script from "./BrandTable.vue?vue&type=script&lang=js&"
export * from "./BrandTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b241a5",
  null
  
)

export default component.exports